<section [formGroup]="group" class="condition-form-group">
    <mat-form-field class="param-field">
        <mat-label>Parametro</mat-label>
        <mat-select formControlName="parameterId">
            @for(parameter of parameters; track parameter){
                <mat-option [value]="parameter.minuteApprovalParameterId">
                    {{parameter.name}}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Comparador</mat-label>
            <mat-select formControlName="comparator">
                <mat-option *ngFor="let comparator of constraintParameter?.allowedComparators|keyvalue"
                    [value]="comparator.key">
                    {{comparator.value}}
                </mat-option>
            </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-label>Valor</mat-label>
        @if(constraintParameter?.allowedValues.size > 0) {
            <mat-select formControlName="value">
                <mat-option *ngFor="let allowedValue of constraintParameter?.allowedValues|keyvalue"
                    [value]="allowedValue.key">
                    {{allowedValue.value}}
                </mat-option>
            </mat-select>
        } @else {
            <input matInput formControlName="value" mask="separator" thousandSeparator=".">
        }
    </mat-form-field>


</section>